import {version} from '../../package.json';
const fb = require("../firebase.js");
import router from '../router'

export default {
  namespaced: true,
  state: {
    toUpdate: false,
  },
  mutations: {
    setToUpdate(state) {
      state.toUpdate = true;
    },
  },
  actions: {
    update() {
      router.push("/update");
      setTimeout(function () {
        location.reload();
      }, 40);
    },
    getVersion({ commit }) {
      fb.db
        .collection("version")
        .doc("version")
        .get()
        .then(doc => {
          console.log("version:", doc.data().version );
          if (doc.data().version !== version){
            commit("setToUpdate");
          }
        });
    },
  },
}
  